module.exports = __webpack_public_path__ + "img/80024.abe96677.png";